import { render } from "./AnswerRecord.vue?vue&type=template&id=058b377e&scoped=true&ts=true"
import script from "./AnswerRecord.vue?vue&type=script&lang=ts"
export * from "./AnswerRecord.vue?vue&type=script&lang=ts"

import "./AnswerRecord.vue?vue&type=style&index=0&id=058b377e&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058b377e"]])

export default __exports__